import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cross-circle",
  "use": "cross-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"cross-circle\">\n  <path fill-rule=\"evenodd\" d=\"M308.315,119.718l-1.308-1.308-1.313,1.312a0.992,0.992,0,0,1-1.4-1.4l1.312-1.313-1.312-1.312a0.992,0.992,0,0,1,1.4-1.4l1.313,1.312,1.308-1.308a0.992,0.992,0,1,1,1.4,1.4l-1.308,1.309,1.308,1.308A0.992,0.992,0,1,1,308.315,119.718ZM299,117a8,8,0,1,0,8-8A8,8,0,0,0,299,117Z\" transform=\"translate(-299 -109)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/cross-circle.svg
// module id = null
// module chunks = 